import React from 'react';
import './gallery.css'

import step1 from '../src/images/step1.png'
import step2 from '../src/images/step2.png'
import step3 from '../src/images/step3.png'
import step4 from '../src/images/step4.png'
import step5 from '../src/images/step5.png'
import step6 from '../src/images/step6.png'

const steps = [
  { icon:step1, title: 'Consultation', desc: 'We understand your vision and needs.' },
  { icon: step2, title: 'Site Visit', desc: 'We assess the site and collect details.' },
  { icon: step3, title: 'Design', desc: 'We provide detailed planning & layouts.' },
  { icon:step4, title: 'Quotation', desc: 'You receive a clear quote and timeline.' },
  { icon: step5, title: 'Construction', desc: 'Our expert team builds your project.' },
//   { icon: '✔️', title: 'Quality Check', desc: 'We ensure quality in every detail.' },
  { icon: step6, title: 'Handover', desc: 'Final walkthrough and site delivery.' },
];

const HowItWorks = () => {
  return (
    <section className="p-4 how-it-works-section" id="howwework">
        <div className="text-sm">
     <h3 style={{fontWeight:'20px',letterSpacing:'2px',color:"hsl(255, 93%, 30%)"}}>How We Work</h3>
      <h6 className='text-secondary'>Turning your vision into concrete reality, step by step.</h6>
      </div>
      <div className="circle-container">
        {steps.map((step, index) => (
          <div className={`circle-item item-${index + 1}`} key={index}>
            <div className="card">
              <div className="icon"><img src={step.icon} height="35px" width="auto"/></div>
              <h6>{step.title}</h6>
            <p className='text-secondary' style={{fontSize:'15px'}}>{step.desc}</p>
            </div>
          </div>
        ))}
        
     <div className="center-text">
     <h3 className='title' style={{fontWeight:'20px',letterSpacing:'2px',color:"hsl(255, 93%, 30%)"}}>How We Work</h3>
      <h6 className="subtitle text-secondary">Turning your vision into concrete reality, step by step.</h6>

        </div> 
      </div>
    </section>
  );
};

export default HowItWorks;
